import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import Logo from './Logo';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Token di verifica mancante.');
      return;
    }
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/verify-email?token=${token}`)
      .then(r => r.json())
      .then(data => {
        if (data.verified) {
          setStatus('success');
          setMessage(data.message || 'Email verificata con successo!');
        } else {
          setStatus('error');
          setMessage(data.detail || data.message || 'Token non valido.');
        }
      })
      .catch(() => {
        setStatus('error');
        setMessage('Errore di connessione. Riprova.');
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center" data-testid="verify-email-page">
        <Logo size={48} className="mx-auto mb-6" />
        {status === 'loading' && (
          <div className="space-y-4">
            <Loader2 className="w-12 h-12 text-[#0055FF] animate-spin mx-auto" />
            <p className="text-[#A1A1AA]">Verifica in corso...</p>
          </div>
        )}
        {status === 'success' && (
          <div className="space-y-4">
            <div className="w-16 h-16 rounded-full bg-[#10B981]/10 flex items-center justify-center mx-auto">
              <CheckCircle2 className="w-8 h-8 text-[#10B981]" />
            </div>
            <h1 className="font-['Outfit'] text-2xl font-medium">{message}</h1>
            <p className="text-[#A1A1AA]">Il tuo account e attivo. Puoi accedere alla dashboard.</p>
            <Link to="/login" className="inline-block bg-[#0055FF] hover:bg-[#3377FF] text-white rounded-full px-8 py-3 text-sm font-medium transition-colors mt-4" data-testid="verify-go-login">
              Accedi alla Dashboard
            </Link>
          </div>
        )}
        {status === 'error' && (
          <div className="space-y-4">
            <div className="w-16 h-16 rounded-full bg-[#EF4444]/10 flex items-center justify-center mx-auto">
              <XCircle className="w-8 h-8 text-[#EF4444]" />
            </div>
            <h1 className="font-['Outfit'] text-2xl font-medium">Verifica fallita</h1>
            <p className="text-[#A1A1AA]">{message}</p>
            <Link to="/login" className="inline-block text-[#0055FF] hover:underline text-sm mt-4">
              Torna al login
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
